import { MedicoesInput, ObjetivoInput, PuericulturaInput } from 'graphql/types.generated'
import { parseNumber } from 'util/number'

import { ObjetivoFormModel } from './ObjetivoForm'
import { PuericulturaModel } from './puericultura/PuericulturaView'

export const convertObjetivoFormToInput = (form: ObjetivoFormModel): ObjetivoInput =>
  form && {
    texto: form.texto,
    medicoes: convertMedicoesToInput(form),
    necessidadesEspeciais: form.necessidadesEspeciais,
    puericultura: form?.puericultura && convertPuericulturaToInput(form?.puericultura),
  }

export const convertMedicoesToInput = (form: ObjetivoFormModel): MedicoesInput => {
  const { openedAccordions, ...rest } = form.medicoes
  return {
    dum: form.dum,
    vacinacaoEmDia: form.vacinacaoEmDia,
    altura: parseNumber(rest?.altura),
    circunferenciaAbdominal: parseNumber(rest?.circunferenciaAbdominal),
    frequenciaCardiaca: parseNumber(rest?.frequenciaCardiaca),
    frequenciaRespiratoria: parseNumber(rest?.frequenciaRespiratoria),
    perimetroCefalico: parseNumber(rest?.perimetroCefalico),
    perimetroPanturrilha: parseNumber(rest?.perimetroPanturrilha),
    peso: parseNumber(rest?.peso),
    pressaoArterialDiastolica: parseNumber(rest?.pressaoArterialDiastolica),
    pressaoArterialSistolica: parseNumber(rest?.pressaoArterialSistolica),
    saturacaoO2: parseNumber(rest?.saturacaoO2),
    glicemia: parseNumber(rest?.glicemia),
    temperatura: parseNumber(rest?.temperatura),
    tipoGlicemia: rest?.tipoGlicemia,
  }
}

const convertPuericulturaToInput = (values: PuericulturaModel): PuericulturaInput => ({
  tipoParto: values.prenatal?.tipoParto?.value,
  tipoGravidez: values.prenatal?.tipoGravidez?.value,
  tipoAleitamento: values.prenatal?.tipoAleitamento,
  apgarUm: values.prenatal?.apgarUm,
  apgarCinco: values.prenatal?.apgarCinco,
  apgarDez: values.prenatal?.apgarDez,
  altura: parseNumber(values.prenatal?.comprimento),
  peso: parseNumber(values.prenatal?.peso),
  perimetroCefalico: parseNumber(values.prenatal?.perimetroCefalico),
  iGDias: values.prenatal?.idadeGestacional?.dias,
  iGSemanas: values.prenatal?.idadeGestacional?.semanas,
})
